import store from "../store";

export const MONTHS = [
    'January',
    'Febuary',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]


export const sleep  = async(ms:number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const get_url_query = (query:string) =>{
    try{
        return new URLSearchParams(window.location.search).get(query) 
    }
    catch(e){
        return null;
    }
}
export const is_on_page = (page:string, strict?:boolean) =>{
    let state = store.getState();
    // console.log("IS ON PAGE",state.history?.history?.location?.pathname)
    return strict ? state.history?.history?.location?.pathname === page : new RegExp(`${page}\/{0,1}.*`).test(state.history?.history?.location?.pathname);
}


export class LogDuration{
    start: Date
    last?: Date
    constructor(){
        this.start = new Date();
    }

    diff = (_since:Date) =>{
        let since = new Date().getTime() - _since.getTime();
        let time_since;
        if(since < 1000){
            time_since = `${since}ms`;
        }
        else if(since < (1000 * 60)){
            let val = since/(1000);
            let floor = Math.floor(val);
            time_since = `${floor}s${val - floor}ms`;
        }
        else{
            let val = since/ (1000 * 60);
            let floor = Math.floor(val);
            time_since = `${floor}m${val - floor}s`;
        }
        return time_since;
    }

    time_since = (message?:string) =>{
        let last_since = this.last ? ` (${this.diff(this.last)})` : '';
        this.last = new Date();
        console.debug(`${message} time since : ${this.diff(this.start)}${last_since}`)
    }
}